<template>
  <main id="main" class="main">
    <section class="section">
      <div class="row">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body p-4">
              <div class="row align-items-center mb-3">
                <div class="col-sm-8">
                  <div class="pagetitle"> 
                    <h1 class="text-left">BROADCAST QUEUE</h1>
                    <nav>
                      <ol class="breadcrumb breadJa mb-0">
                        <router-link :to="{ name: 'home' }" class="breadcrumb-item">Home</router-link>
                        <router-link :to="{ name: 'broadcast' }" class="breadcrumb-item">Broadcast Queue</router-link>
                      </ol>
                    </nav>
                  </div>
                </div> 
                <div class="col-sm-4 d-flex justify-content-sm-end align-items-center mt-2 mt-sm-0">
                  <button
                    class="btn btn-primary shadow-sm"
                    data-bs-toggle="modal"
                    data-bs-target="#createQueueModal"
                    style="height: 38px;"
                    @click="resetForms"
                  >
                    <i class="bi bi-plus-circle me-1"></i> Tambah Queue
                  </button>
                </div>
              </div>

              <div class="row align-items-center mb-3 g-2">
                <!-- Filter Left: Status, Application, Filter, Reset -->
                <div class="col-md-7 d-flex align-items-center gap-2 flex-wrap">
                  <!-- Status Filter -->
                  <div style="width: 140px;">
                    <select 
                      v-model="filterStatus" 
                      class="form-select" 
                      style="height: 38px;" 
                      @change="currentPage = 1; fetchData()"
                    >
                      <option value="">All Status</option>
                      <option :value="0">0 - Pending</option>
                      <option :value="1">1 - Success</option>
                      <option :value="2">2 - Failed</option>
                      <option :value="3">3 - Processing</option>
                    </select>
                  </div>

                  <!-- Application Filter Dropdown -->
                  <div style="width: 160px;">
                    <select
                      v-model="filterApplication"
                      class="form-select"
                      style="height: 38px;"
                      @change="currentPage = 1; fetchData()"
                    >
                      <option value="">All Application</option>
                      <option v-for="app in availableApplications" :key="app" :value="app">
                        {{ app }}
                      </option>
                    </select>
                  </div>

                  <!-- Action Buttons -->
                  <button
                    class="btn btn-primary shadow-sm"
                    @click="currentPage = 1; fetchData()"
                    :disabled="loading"
                    style="height: 38px;"
                  >
                    <i class="bi bi-funnel me-1"></i> Filter
                  </button>
                </div>

                <!-- Right: Search Box & Entries -->
                <div class="col-md-5 d-flex justify-content-md-end align-items-center gap-2 flex-wrap">
                  <!-- Search Box -->
                  <div style="position: relative; width: 200px;">
                    <i class="bi bi-search text-muted" style="position: absolute; left: 12px; top: 50%; transform: translateY(-50%); pointer-events: none;"></i>
                    <input
                      type="text"
                      v-model="searchQuery"
                      class="form-control"
                      placeholder="Search queue..."
                      @keyup.enter="currentPage = 1; fetchData()"
                      style="padding-left: 35px; height: 38px;"
                    />
                  </div>

                  <!-- Show Entries -->
                  <div class="d-flex align-items-center">
                    <span class="me-1 text-muted small">Show</span>
                    <select v-model="selectedEntries" class="form-select form-select-sm" style="width: auto; height: 38px;" @change="currentPage = 1; fetchData()">
                      <option :value="10">10</option>
                      <option :value="20">20</option>
                      <option :value="50">50</option>
                      <option :value="100">100</option>
                    </select>
                  </div>
                </div>
              </div>

              <!-- Active Filters Badges -->
              <div v-if="searchQuery || filterStatus !== '' || filterApplication" class="d-flex align-items-center gap-2 mb-3 flex-wrap bg-light p-2 rounded border">
                <span class="small fw-bold text-muted me-1"><i class="bi bi-funnel-fill me-1 text-primary"></i> Active Filters:</span>
                
                <span v-if="searchQuery" class="badge bg-white text-dark border d-flex align-items-center gap-1 shadow-sm px-2 py-1">
                  Search: <strong>"{{ searchQuery }}"</strong>
                  <i class="bi bi-x-circle-fill text-danger ms-1" @click="searchQuery = ''; currentPage = 1; fetchData()" style="cursor: pointer;" title="Remove search filter"></i>
                </span>

                <span v-if="filterStatus !== ''" class="badge bg-primary d-flex align-items-center gap-1 shadow-sm px-2 py-1">
                  Status: <strong>{{ formatStatusLabel(filterStatus) }}</strong>
                  <i class="bi bi-x-circle-fill text-white-50 ms-1" @click="filterStatus = ''; currentPage = 1; fetchData()" style="cursor: pointer;" title="Remove status filter"></i>
                </span>

                <span v-if="filterApplication" class="badge bg-info text-dark border d-flex align-items-center gap-1 shadow-sm px-2 py-1">
                  App: <strong>{{ filterApplication }}</strong>
                  <i class="bi bi-x-circle-fill text-secondary ms-1" @click="filterApplication = ''; currentPage = 1; fetchData()" style="cursor: pointer;" title="Remove application filter"></i>
                </span>

                <button class="btn btn-link btn-sm text-danger ms-auto p-0 text-decoration-none fw-bold small" @click="resetFilters">
                  <i class="bi bi-x-lg me-1"></i> Clear All
                </button>
              </div>

              <!-- Bulk Action Toolbar -->
              <div v-if="selectedIds.length > 0" class="alert alert-primary border shadow-sm py-2 px-3 mb-3 d-flex align-items-center justify-content-between flex-wrap gap-2 fade-in-child-row">
                <div class="d-flex align-items-center gap-2">
                  <i class="bi bi-check2-square fs-5 text-primary"></i>
                  <span class="fw-bold text-dark">{{ selectedIds.length }} item queue terpilih</span>
                </div>
                <div class="d-flex align-items-center gap-2">
                  <label class="small fw-bold mb-0 text-dark">Ubah Status Ke:</label>
                  <select v-model="targetBulkStatus" class="form-select form-select-sm" style="width: 180px;">
                    <option value="">-- Pilih Status --</option>
                    <option :value="0">0 - Pending</option>
                    <option :value="1">1 - Success</option>
                    <option :value="2">2 - Failed</option>
                    <option :value="3">3 - Processing</option>
                  </select>
                  <button 
                    class="btn btn-sm btn-success fw-bold px-3" 
                    :disabled="targetBulkStatus === '' || loadingBulkStatus"
                    @click="executeBulkStatusUpdate"
                  >
                    <span v-if="loadingBulkStatus" class="spinner-border spinner-border-sm me-1"></span>
                    <i v-else class="bi bi-check-lg me-1"></i> Update Status
                  </button>
                  <button class="btn btn-sm btn-outline-secondary" @click="selectedIds = []; selectAll = false;">
                    Batal
                  </button>
                </div>
              </div>

              <!-- table -->
              <div class="table-responsive">
                <table class="table table-hover table-bordered caption-top">
                  <caption class="pb-2 pt-1">List of Broadcast Queue</caption>

                  <thead class="table-primary">
                    <tr style="vertical-align:middle; text-align: center;">
                      <th scope="col" style="width: 75px;" nowrap>
                        <input type="checkbox" class="form-check-input align-middle me-1" v-model="selectAll" @change="toggleSelectAll" title="Pilih Semua di Halaman Ini" />
                      </th>
                      <th scope="col" style="width: 50px;">No</th>
                      <th scope="col">From Number</th>
                      <th scope="col">Destination</th>
                      <th scope="col">Application</th>
                      <th scope="col">Message</th>
                      <th scope="col">Status</th>
                      <th scope="col">Sending Datetime</th>
                      <th scope="col">Error Message</th>
                    </tr>
                  </thead>

                  <tbody class="table-group-divider">
                    <tr v-if="loading">
                      <td colspan="20">
                        <div class="d-flex justify-content-center text-primary m-3">
                          <strong role="status" class="pt-1" style="padding-right: 2rem;">Loading...</strong>
                          <div class="spinner-border shadow" aria-hidden="true"></div>
                        </div>
                      </td>
                    </tr>

                    <template v-else-if="items.length > 0">
                      <template v-for="(item, index) in items" :key="item.id_outbox">
                        <tr style="vertical-align:middle;" class="fade-in-pengaduan-view" :class="{ 'table-active': selectedIds.includes(item.id_outbox) }">
                          <td style="text-align: center;" nowrap>
                            <button
                              class="btn btn-sm btn-link p-0 text-decoration-none me-2 align-middle"
                              @click="toggleExpandRow(item.id_outbox)"
                              :title="expandedRowIds.includes(item.id_outbox) ? 'Tutup Detail' : 'Buka Detail'"
                            >
                              <i
                                class="bi fs-5 align-middle"
                                :class="expandedRowIds.includes(item.id_outbox) ? 'bi-dash-circle-fill text-danger' : 'bi-plus-circle-fill text-primary'"
                              ></i>
                            </button>
                            <input type="checkbox" class="form-check-input align-middle" :value="item.id_outbox" v-model="selectedIds" />
                          </td>
                          <th scope="row" style="text-align: center;" nowrap>
                            {{ (currentPage - 1) * selectedEntries + index + 1 }}
                          </th>
                          <td nowrap style="text-align: center;">{{ item.from_number || '-' }}</td>
                          <td nowrap style="text-align: center;">{{ item.destination || '-' }}</td>
                          <td nowrap style="text-align: center;">
                            <span class="badge bg-light text-dark border">{{ item.application || '-' }}</span>
                          </td>
                          <td style="text-align: left; max-width: 180px;">
                            <button 
                              v-if="item.file" 
                              class="btn btn-sm btn-outline-info py-0 px-1 me-1 align-middle" 
                              @click.stop="openMediaPreviewModal(item.file)"
                              title="Preview Media / File"
                            >
                              <i class="bi bi-paperclip"></i>
                            </button>
                            <span 
                              class="text-truncate d-inline-block align-middle" 
                              style="max-width: 150px;"
                              :title="item.messages || '-'"
                            >
                              {{ item.messages || '-' }}
                            </span>
                          </td>
                          <td nowrap style="text-align: center; width: 5%;">
                            <i
                              class="bi"
                              :class="{
                                'bi-check-circle-fill text-success fs-5': item.status === 1,
                                'bi-hourglass-split text-warning fs-5': item.status === 0,
                                'bi-exclamation-circle-fill text-danger fs-5': item.status === 2,
                                'bi-arrow-clockwise text-primary fs-5 spin-icon': item.status === 3
                              }"
                              :title="formatStatusLabel(item.status)"
                            ></i>
                          </td>
                          <td nowrap style="text-align: center;">{{ formatDate(item.sending_datetime) }}</td>
                          <td nowrap style="text-align: center;">
                            <span 
                              v-if="item.msg_error" 
                              class="text-danger small fw-semibold cursor-pointer" 
                              :title="item.msg_error"
                            >
                              {{ item.msg_error.length > 20 ? item.msg_error.substring(0, 20) + '...' : item.msg_error }}
                            </span>
                            <span v-else class="text-muted">-</span>
                          </td>
                        </tr>

                        <!-- Expandable Child Table Row -->
                        <tr v-if="expandedRowIds.includes(item.id_outbox)" class="bg-light fade-in-child-row">
                          <td colspan="9" class="p-3">
                            <div class="card card-body border shadow-sm p-3 bg-white">
                              <div class="d-flex align-items-center justify-content-between mb-2 pb-2 border-bottom">
                                <h6 class="fw-bold text-primary mb-0">
                                  <i class="bi bi-card-heading me-1"></i> Detail Queue Outbox (#{{ item.id_outbox }})
                                </h6>
                                <div class="d-flex align-items-center gap-2">
                                  <span class="badge" :class="{
                                    'bg-success': item.status === 1,
                                    'bg-warning text-dark': item.status === 0,
                                    'bg-danger': item.status === 2,
                                    'bg-primary': item.status === 3
                                  }">
                                    {{ formatStatusLabel(item.status) }}
                                  </span>

                                  <div class="dropdown">
                                    <button class="btn btn-sm btn-outline-secondary dropdown-toggle py-0 px-2 small" type="button" data-bs-toggle="dropdown">
                                      <i class="bi bi-pencil-square me-1"></i> Ubah Status
                                    </button>
                                    <ul class="dropdown-menu dropdown-menu-end shadow">
                                      <li><a class="dropdown-item small" href="javascript:void(0)" @click="changeSingleStatus(item.id_outbox, 0)">0 - Pending</a></li>
                                      <li><a class="dropdown-item small" href="javascript:void(0)" @click="changeSingleStatus(item.id_outbox, 1)">1 - Success</a></li>
                                      <li><a class="dropdown-item small" href="javascript:void(0)" @click="changeSingleStatus(item.id_outbox, 2)">2 - Failed</a></li>
                                      <li><a class="dropdown-item small" href="javascript:void(0)" @click="changeSingleStatus(item.id_outbox, 3)">3 - Processing</a></li>
                                    </ul>
                                  </div>
                                </div>
                              </div>

                              <div class="row g-3">
                                <div class="col-md-6">
                                  <table class="table table-sm table-borderless mb-0">
                                    <tbody>
                                      <tr>
                                        <td class="fw-bold text-muted" style="width: 35%;">ID Outbox:</td>
                                        <td>{{ item.id_outbox }}</td>
                                      </tr>
                                      <tr>
                                        <td class="fw-bold text-muted">From Number:</td>
                                        <td>{{ item.from_number || '-' }}</td>
                                      </tr>
                                      <tr>
                                        <td class="fw-bold text-muted">Destination:</td>
                                        <td><code>{{ item.destination || '-' }}</code></td>
                                      </tr>
                                      <tr>
                                        <td class="fw-bold text-muted">Application:</td>
                                        <td><span class="badge bg-secondary">{{ item.application || '-' }}</span></td>
                                      </tr>
                                      <tr>
                                        <td class="fw-bold text-muted">Type:</td>
                                        <td>{{ item.type || '-' }}</td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>

                                <div class="col-md-6">
                                  <table class="table table-sm table-borderless mb-0">
                                    <tbody>
                                      <tr>
                                        <td class="fw-bold text-muted" style="width: 35%;">Sending Datetime:</td>
                                        <td>{{ formatDate(item.sending_datetime) }}</td>
                                      </tr>
                                      <tr>
                                        <td class="fw-bold text-muted">Insert Datetime:</td>
                                        <td>{{ formatDate(item.insert_datetime) }}</td>
                                      </tr>
                                      <tr>
                                        <td class="fw-bold text-muted">Error Count:</td>
                                        <td><span class="badge bg-light text-dark border">{{ item.error_count || 0 }}</span></td>
                                      </tr>
                                      <tr>
                                        <td class="fw-bold text-muted">Error Message:</td>
                                        <td class="text-danger small">{{ item.msg_error || '-' }}</td>
                                      </tr>
                                      <tr>
                                        <td class="fw-bold text-muted">File URL:</td>
                                        <td>
                                          <div v-if="item.file" class="d-flex align-items-center gap-2 flex-wrap">
                                            <a :href="item.file" target="_blank" class="text-break small">
                                              {{ item.file }} <i class="bi bi-box-arrow-up-right ms-1"></i>
                                            </a>
                                            <button 
                                              class="btn btn-sm btn-outline-primary py-0 px-2 fw-semibold" 
                                              @click="openMediaPreviewModal(item.file)"
                                            >
                                              <i class="bi bi-eye-fill me-1"></i> Preview File
                                            </button>
                                          </div>
                                          <span v-else class="text-muted">-</span>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>

                              <!-- Message Content Box -->
                              <div class="mt-3">
                                <label class="fw-bold text-muted small mb-1">Message Content:</label>
                                <div class="p-2 bg-light border rounded text-start" style="white-space: pre-wrap; font-family: monospace; font-size: 0.85rem; max-height: 200px; overflow-y: auto;">
                                  {{ item.messages || '-' }}
                                </div>
                              </div>
                            </div>
                          </td>
                        </tr>
                      </template>
                    </template>

                    <tr v-if="!loading && items.length === 0">
                      <td colspan="10" class="text-center">No results found.</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- Pagination & Entries Info -->
              <div class="row align-items-center mt-3">
                <div class="col-md-6 text-center text-md-start mb-3 mb-md-0">
                  <p class="text-muted mb-0 small">
                    Showing {{ startEntryData }} to {{ endEntryData }} of {{ totalItemsData }} entries
                  </p>
                </div>
                <div class="col-md-6">
                  <nav aria-label="Page navigation" v-if="totalPages > 1">
                    <ul class="pagination pagination-sm justify-content-center justify-content-md-end mb-0 flex-wrap">
                      <li class="page-item" :class="{ disabled: currentPage === 1 }">
                        <button class="page-link" @click="changePage(currentPage - 1)" aria-label="Previous">
                          <span aria-hidden="true">&laquo;</span>
                        </button>
                      </li>
                      <li
                        v-for="(page, idx) in displayedPages"
                        :key="idx"
                        class="page-item"
                        :class="{ active: currentPage === page, disabled: page === '...' }"
                      >
                        <button v-if="page !== '...'" class="page-link" @click="changePage(page)">
                          {{ page }}
                        </button>
                        <span v-else class="page-link">...</span>
                      </li>
                      <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                        <button class="page-link" @click="changePage(currentPage + 1)" aria-label="Next">
                          <span aria-hidden="true">&raquo;</span>
                        </button>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>

              <!-- Information Banner Note -->
              <div class="alert alert-info border-0 shadow-sm mt-4 mb-0 d-flex align-items-center gap-3">
                <i class="bi bi-info-circle-fill text-info fs-3 flex-shrink-0"></i>
                <div>
                  <h6 class="fw-bold mb-1">Info Alur Eksekusi Broadcast:</h6>
                  <p class="mb-0 small text-dark">
                    Pesan yang ada di dalam <strong>Broadcast Queue</strong> ini akan dieksekusi dan dikirim secara otomatis oleh sistem saat <strong>Worker</strong> telah dikonfigurasi dan aktif berjalan (RUNNING). 
                    Anda dapat memeriksa status atau mengkonfigurasi worker di halaman 
                    <router-link :to="{ name: 'worker-config' }" class="fw-bold text-decoration-underline text-primary">
                      Worker Config <i class="bi bi-arrow-right-short"></i>
                    </router-link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Modal Tambah Queue -->
    <div class="modal fade" id="createQueueModal" tabindex="-1" aria-hidden="true" ref="createQueueModalRef">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header py-2">
            <h6 class="modal-title mb-0">Tambah Broadcast Queue</h6>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>

          <div class="modal-body p-3">
            <!-- Modal Tip -->
            <div class="alert alert-light border small text-muted mb-3 py-2 px-3">
              <i class="bi bi-gear-fill me-1 text-primary"></i> 
              <strong>Alur Pengiriman:</strong> Setelah menginput antrean, pesan akan dikirim otomatis saat <strong>Worker</strong> berjalan (RUNNING). Kelola worker di 
              <router-link :to="{ name: 'worker-config' }" class="fw-bold text-decoration-none" data-bs-dismiss="modal">Worker Config</router-link>.
            </div>
            <!-- Navigation Tabs -->
            <ul class="nav nav-tabs mb-3" id="queueTabs" role="tablist">
              <li class="nav-item" role="presentation">
                <button
                  class="nav-link"
                  :class="{ active: activeTab === 'single' }"
                  @click="activeTab = 'single'"
                  type="button"
                >
                  <i class="bi bi-person-fill me-1"></i> Format Satuan
                </button>
              </li>
              <li class="nav-item" role="presentation">
                <button
                  class="nav-link"
                  :class="{ active: activeTab === 'excel' }"
                  @click="activeTab = 'excel'"
                  type="button"
                >
                  <i class="bi bi-file-earmark-excel-fill me-1"></i> Import Excel
                </button>
              </li>
              <li class="nav-item" role="presentation">
                <button
                  class="nav-link"
                  :class="{ active: activeTab === 'bulk' }"
                  @click="activeTab = 'bulk'"
                  type="button"
                >
                  <i class="bi bi-file-earmark-code-fill me-1"></i> JSON Bulk
                </button>
              </li>
            </ul>

            <!-- Tab Contents -->
            <div class="tab-content">
              <!-- Single Format Tab -->
              <div v-if="activeTab === 'single'" class="fade-in-pengaduan-view">
                <form @submit.prevent="submitSingleQueue">
                  <div class="row">
                    <div class="col-md-6 mb-3">
                      <div class="d-flex justify-content-between align-items-center mb-1">
                        <label class="form-label fw-bold mb-0">Destination <span class="text-danger">*</span></label>
                        <!-- WA Status Badge -->
                        <span v-if="singleForm.destination && singleForm.destination.trim().length >= 8">
                          <span v-if="checkingDestination" class="badge bg-info text-dark">
                            <span class="spinner-border spinner-border-sm me-1"></span> Check WA...
                          </span>
                          <span v-else-if="destinationCheckStatus === 'valid'" class="badge bg-success" :title="destinationCheckNote">
                            <i class="bi bi-whatsapp me-1"></i> WA Terdaftar
                          </span>
                          <span v-else-if="destinationCheckStatus === 'invalid'" class="badge bg-warning text-dark" :title="destinationCheckNote">
                            <i class="bi bi-exclamation-circle me-1"></i> Tidak Terdaftar (Tetap Bisa Simpan)
                          </span>
                          <span v-else-if="destinationCheckStatus === 'no_instance'" class="badge bg-secondary" :title="destinationCheckNote">
                            <i class="bi bi-info-circle me-1"></i> Check Off (Instance Offline)
                          </span>
                        </span>
                      </div>
                      <input
                        type="text"
                        inputmode="numeric"
                        class="form-control"
                        :class="{
                          'is-valid': destinationCheckStatus === 'valid'
                        }"
                        v-model="singleForm.destination"
                        placeholder="e.g. 628123456789"
                        @input="onDestinationInput"
                        required
                      />
                      <small v-if="destinationCheckNote" class="d-block mt-1 small" :class="destinationCheckStatus === 'valid' ? 'text-success' : 'text-warning text-dark'">
                        <i class="bi bi-info-circle me-1"></i> {{ destinationCheckNote }} (Tetap bisa disubmit ke queue)
                      </small>
                    </div>

                    <div class="col-md-6 mb-3">
                      <div class="d-flex justify-content-between align-items-center mb-1">
                        <label class="form-label fw-bold mb-0">Application</label>
                        <a 
                          href="javascript:void(0)" 
                          class="small text-decoration-none fw-bold"
                          @click="isCustomAppInput = !isCustomAppInput; singleForm.application = ''"
                        >
                          {{ isCustomAppInput ? '← Pilih dari Dropdown' : '+ Input Aplikasi Baru' }}
                        </a>
                      </div>

                      <select v-if="!isCustomAppInput" class="form-select" v-model="singleForm.application">
                        <option value="">-- Select Application --</option>
                        <option v-for="app in availableApplications" :key="app" :value="app">
                          {{ app }}
                        </option>
                      </select>

                      <input
                        v-else
                        type="text"
                        class="form-control"
                        v-model="singleForm.application"
                        placeholder="Ketik nama aplikasi baru... (e.g. MARKETING)"
                      />
                    </div>
                  </div>

                  <div class="mb-3">
                    <label class="form-label fw-bold">File URL / Media Link</label>
                    <input
                      type="url"
                      class="form-control"
                      v-model="singleForm.file"
                      placeholder="e.g. https://domain.com/banner.jpg"
                      @input="onFileUrlInput"
                    />
                    <small class="text-muted mt-1 d-block">
                      <i class="bi bi-info-circle me-1"></i> Masukkan URL publik file media (bukan file fisik lokal).
                    </small>

                    <!-- Live Media Preview Box -->
                    <div v-if="singleForm.file && singleForm.file.trim() !== ''" class="mt-2 p-2 border rounded bg-light">
                      <div class="d-flex align-items-center justify-content-between mb-1">
                        <span class="fw-bold small text-muted"><i class="bi bi-eye me-1"></i> Media Preview:</span>
                        <a :href="singleForm.file" target="_blank" class="small text-decoration-none fw-bold">
                          Open Link <i class="bi bi-box-arrow-up-right ms-1"></i>
                        </a>
                      </div>

                      <!-- Image Preview -->
                      <div v-if="isImagePreview" class="text-center bg-white p-2 border rounded shadow-sm">
                        <img
                          :src="singleForm.file"
                          alt="Media Preview"
                          style="max-height: 160px; max-width: 100%; object-fit: contain;"
                          @error="onMediaPreviewError"
                          @load="onMediaPreviewLoad"
                        />
                      </div>

                      <!-- Non-image or Failed Image Fallback -->
                      <div v-else class="p-2 bg-white border rounded d-flex align-items-center gap-2">
                        <i class="bi bi-file-earmark-text text-primary fs-3"></i>
                        <div class="text-truncate">
                          <div class="fw-bold small text-truncate">{{ singleForm.file }}</div>
                          <small class="text-muted">Direct File / Document URL Link</small>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="mb-3">
                    <label class="form-label fw-bold">Messages <span class="text-danger">*</span></label>
                    <textarea
                      class="form-control"
                      rows="4"
                      v-model="singleForm.messages"
                      placeholder="Message content..."
                      required
                    ></textarea>
                  </div>

                  <div class="text-end">
                    <button type="button" class="btn btn-secondary me-2" data-bs-dismiss="modal">Cancel</button>
                    <button type="submit" class="btn btn-primary" :disabled="loadingSubmit">
                      <span v-if="loadingSubmit" class="spinner-border spinner-border-sm me-1"></span>
                      Submit Queue
                    </button>
                  </div>
                </form>
              </div>

              <!-- Import Excel Tab -->
              <div v-if="activeTab === 'excel'" class="fade-in-pengaduan-view">
                <div class="card bg-light border-0 mb-3">
                  <div class="card-body p-3">
                    <div class="d-flex justify-content-between align-items-center">
                      <div>
                        <h6 class="fw-bold mb-1"><i class="bi bi-file-earmark-excel me-1 text-success"></i> Download Template Excel</h6>
                        <small class="text-muted">Gunakan template resmi untuk menyesuaikan format data broadcast queue.</small>
                      </div>
                      <button 
                        type="button" 
                        class="btn btn-sm btn-outline-success" 
                        @click="downloadExcelTemplate"
                        :disabled="loadingDownload"
                      >
                        <span v-if="loadingDownload" class="spinner-border spinner-border-sm me-1"></span>
                        <i v-else class="bi bi-download me-1"></i> Download Template
                      </button>
                    </div>
                  </div>
                </div>

                <form @submit.prevent="submitExcelImport">
                  <div class="mb-3">
                    <label class="form-label fw-bold">Pilih File Excel (.xlsx / .xls) <span class="text-danger">*</span></label>
                    <input
                      type="file"
                      class="form-control"
                      ref="excelFileInput"
                      accept=".xlsx, .xls"
                      @change="handleExcelFileChange"
                      required
                    />
                    <small class="text-muted mt-1 d-block">
                      Form Key upload: <code>file</code>
                    </small>
                  </div>

                  <div class="text-end">
                    <button type="button" class="btn btn-secondary me-2" data-bs-dismiss="modal">Cancel</button>
                    <button type="submit" class="btn btn-success" :disabled="loadingSubmit || !excelFile">
                      <span v-if="loadingSubmit" class="spinner-border spinner-border-sm me-1"></span>
                      <i class="bi bi-upload me-1"></i> Import Excel Data
                    </button>
                  </div>
                </form>
              </div>

              <!-- Bulk Format Tab -->
              <div v-if="activeTab === 'bulk'" class="fade-in-pengaduan-view">
                <div class="d-flex justify-content-between align-items-center mb-2">
                  <label class="form-label fw-bold mb-0">JSON Input (Array of Objects) <span class="text-danger">*</span></label>
                  <button type="button" class="btn btn-sm btn-outline-primary" @click="loadBulkExample">
                    <i class="bi bi-file-earmark-code me-1"></i> Load Template Example
                  </button>
                </div>
                <textarea
                  class="form-control font-monospace mb-2"
                  rows="10"
                  v-model="bulkJson"
                  placeholder='[\n  {\n    "destination": "628123456781",\n    "messages": "Halo...",\n    "application": "marketing"\n  }\n]'
                  @input="validateBulkJson"
                  style="font-size: 0.85rem;"
                ></textarea>
                
                <div class="mb-3">
                  <span v-if="bulkJson.trim() === ''" class="text-muted small">Input JSON array to validate.</span>
                  <span v-else-if="isValidBulkJson" class="text-success small"><i class="bi bi-check-circle me-1"></i> JSON format is valid.</span>
                  <span v-else class="text-danger small"><i class="bi bi-x-circle me-1"></i> JSON is invalid or not an array.</span>
                </div>

                <div class="text-end">
                  <button type="button" class="btn btn-secondary me-2" data-bs-dismiss="modal">Cancel</button>
                  <button type="button" class="btn btn-primary" :disabled="loadingSubmit || !isValidBulkJson || bulkJson.trim() === ''" @click="submitBulkQueue">
                    <span v-if="loadingSubmit" class="spinner-border spinner-border-sm me-1"></span>
                    Submit Bulk Queue
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Preview Media / File -->
    <div class="modal fade" id="mediaPreviewModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content shadow-lg border-0">
          <div class="modal-header py-2 bg-light">
            <h6 class="modal-title mb-0 fw-bold text-primary">
              <i class="bi bi-eye-fill me-1"></i> Preview Media / File
            </h6>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body text-center p-4 bg-light">
            <div v-if="previewFileUrl">
              <div v-if="isPreviewImage" class="mb-2">
                <img 
                  :src="previewFileUrl" 
                  class="img-fluid rounded shadow-sm border" 
                  style="max-height: 480px; object-fit: contain;" 
                  @error="isPreviewImage = false"
                  alt="Media Preview"
                />
              </div>
              <div v-else class="p-4 bg-white rounded border shadow-sm my-2">
                <i class="bi bi-file-earmark-text text-primary fs-1 mb-2 d-block"></i>
                <h6 class="fw-bold mb-1">File Non-Gambar / Lampiran Dokumen</h6>
                <p class="text-muted small text-break mb-3">{{ previewFileUrl }}</p>
                <a :href="previewFileUrl" target="_blank" class="btn btn-sm btn-primary px-3">
                  <i class="bi bi-box-arrow-up-right me-1"></i> Buka / Download File
                </a>
              </div>
            </div>
          </div>
          <div class="modal-footer py-2">
            <a :href="previewFileUrl" target="_blank" class="btn btn-sm btn-outline-secondary">
              Open in New Tab <i class="bi bi-box-arrow-up-right ms-1"></i>
            </a>
            <button type="button" class="btn btn-sm btn-secondary" data-bs-dismiss="modal">Tutup</button>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import axios from 'axios';
import lottie from 'lottie-web';
import { useSystem } from '@/composables/useSystem.js';

export default {
  name: 'BroadcastQueue',
  setup() {
    const { themeColor } = useSystem();
    return { themeColor };
  },
  computed: {
    displayedPages() {
      const total = this.totalPages;
      const current = this.currentPage;
      const delta = 2;
      const range = [];
      const rangeWithDots = [];
      let l;

      for (let i = 1; i <= total; i++) {
        if (i === 1 || i === total || (i >= current - delta && i <= current + delta)) {
          range.push(i);
        }
      }

      for (let i of range) {
        if (l) {
          if (i - l === 2) {
            rangeWithDots.push(l + 1);
          } else if (i - l !== 1) {
            rangeWithDots.push('...');
          }
        }
        rangeWithDots.push(i);
        l = i;
      }

      return rangeWithDots;
    }
  },
  data() {
    return {
      items: [],
      currentPage: 1,
      totalPages: 1,
      searchQuery: '',
      filterStatus: '',
      filterApplication: 'kliksardjitootp',
      availableApplications: [],
      selectedEntries: 10,
      baseUrl: process.env.VUE_APP_BE_APP_BASE_URL || '',
      loading: false,
      startEntryData: 0,
      endEntryData: 0,
      totalItemsData: 0,
      activeTab: 'single',
      loadingSubmit: false,
      singleForm: {
        destination: '',
        messages: '',
        application: '',
        file: ''
      },
      bulkJson: '',
      isValidBulkJson: true,
      excelFile: null,
      loadingDownload: false,
      isCustomAppInput: false,
      checkingDestination: false,
      destinationCheckStatus: null,
      destinationCheckNote: '',
      destCheckTimeout: null,
      availableOnlineInstances: [],
      isImagePreview: true,
      expandedRowIds: [],
      selectedIds: [],
      selectAll: false,
      targetBulkStatus: '',
      loadingBulkStatus: false,
      previewFileUrl: '',
      isPreviewImage: true
    };
  },
  mounted() {
    this.fetchData();
    this.fetchAvailableApplications();
  },
  methods: {
    async fetchAvailableApplications() {
      try {
        const response = await axios.get(
          `${this.baseUrl}/api/blast-outbox/available-applications`
        );
        if (response.data?.success) {
          this.availableApplications = response.data.data || [];
        }
      } catch (error) {
        console.error('Gagal mengambil daftar aplikasi:', error);
      }
    },

    async fetchData() {
      try {
        this.loading = true;
        this.selectedIds = [];
        this.selectAll = false;

        const params = {
          page: this.currentPage,
          limit: this.selectedEntries
        };

        if (this.searchQuery && this.searchQuery.trim()) {
          params.search = this.searchQuery.trim();
        }
        if (this.filterStatus !== '' && this.filterStatus !== null && this.filterStatus !== undefined) {
          params.status = this.filterStatus;
        }
        if (this.filterApplication && this.filterApplication.trim()) {
          params.application = this.filterApplication.trim();
        }

        const response = await axios.get(
          `${this.baseUrl}/api/blast-outbox/queue`,
          { params }
        );

        if (response.data?.success) {
          const resultData = response.data.data;
          this.items = resultData.data || [];
          
          const pagination = resultData.pagination || {};
          this.totalItemsData = pagination.total_data || this.items.length;
          this.totalPages = pagination.total_pages || 1;
          this.currentPage = pagination.current_page || this.currentPage;

          // Calculate showing entries details
          const startIndex = (this.currentPage - 1) * this.selectedEntries;
          this.startEntryData = this.items.length > 0 ? startIndex + 1 : 0;
          this.endEntryData = startIndex + this.items.length;
        } else {
          this.Toasttt(response.data?.message || 'Gagal mengambil data queue.', 'error');
        }
      } catch (error) {
        console.error('Terjadi kesalahan:', error);
        if (error.response && error.response.status === 401) {
          this.Toasttt('Unauthorized. You do not have access.', 'warning');
        } else {
          this.Toasttt('Gagal mengambil data queue.', 'error');
        }
      } finally {
        this.loading = false;
      }
    },

    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
        this.fetchData();
      }
    },

    toggleExpandRow(id) {
      const index = this.expandedRowIds.indexOf(id);
      if (index > -1) {
        this.expandedRowIds.splice(index, 1);
      } else {
        this.expandedRowIds.push(id);
      }
    },

    toggleSelectAll() {
      if (this.selectAll) {
        this.selectedIds = this.items.map(item => item.id_outbox);
      } else {
        this.selectedIds = [];
      }
    },

    changeSingleStatus(id, newStatus) {
      this.updateBulkStatusApi(newStatus, [id]);
    },

    executeBulkStatusUpdate() {
      if (this.targetBulkStatus === '' || this.selectedIds.length === 0) return;
      this.updateBulkStatusApi(this.targetBulkStatus, this.selectedIds);
    },

    openMediaPreviewModal(url) {
      if (!url) return;
      this.previewFileUrl = url;
      
      const isImgExt = /\.(jpeg|jpg|gif|png|webp|svg)($|\?)/i.test(url);
      this.isPreviewImage = isImgExt;

      const modalEl = document.getElementById('mediaPreviewModal');
      if (modalEl) {
        /* global bootstrap */
        const modal = new bootstrap.Modal(modalEl);
        modal.show();
      }
    },

    async updateBulkStatusApi(toStatus, ids) {
      try {
        this.loadingBulkStatus = true;
        const payload = {
          to_status: Number(toStatus),
          ids: ids.map(id => Number(id))
        };

        const response = await axios.post(
          `${this.baseUrl}/api/blast-outbox/queue/bulk-status`,
          payload
        );

        if (response.data?.success) {
          this.Toasttt(
            response.data?.message || 'Status outbox berhasil diperbarui',
            'success',
            `Berhasil memperbarui ${response.data?.data?.updated_count || ids.length} item status.`
          );
          this.selectedIds = [];
          this.selectAll = false;
          this.targetBulkStatus = '';
          this.fetchData();
        } else {
          this.Toasttt(response.data?.message || 'Gagal memperbarui status outbox.', 'error');
        }
      } catch (error) {
        console.error('Failed to update bulk status:', error);
        this.Toasttt(
          'Gagal memperbarui status outbox',
          'error',
          error.response?.data?.message || ''
        );
      } finally {
        this.loadingBulkStatus = false;
      }
    },

    resetFilters() {
      this.searchQuery = '';
      this.filterStatus = '';
      this.filterApplication = '';
      this.currentPage = 1;
      this.fetchData();
    },

    formatStatusLabel(status) {
      const s = Number(status);
      switch (s) {
        case 0:
          return 'PENDING';
        case 1:
          return 'SUCCESS';
        case 2:
          return 'FAILED';
        case 3:
          return 'PROCESSING';
        default:
          return 'UNKNOWN';
      }
    },

    formatDate(value) {
      if (!value) return '-';
      const d = new Date(value);
      if (isNaN(d.getTime())) return value;
      return d.toLocaleString('id-ID', {
        timeZone: 'UTC',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      });
    },

    async viewQueueDetail(item) {
      await this.$swal.fire({
        title: 'Broadcast Queue Detail',
        html: `
          <div id="lottie-detail-queue" style="width:150px; height:150px; margin:0 auto;"></div>
          <div class="text-start mt-3">
            <table class="table table-sm table-bordered">
              <tbody>
                <tr>
                  <td class="fw-bold" style="width: 35%;">ID Outbox</td>
                  <td>${item.id_outbox}</td>
                </tr>
                <tr>
                  <td class="fw-bold">Type</td>
                  <td>${item.type}</td>
                </tr>
                <tr>
                  <td class="fw-bold">From Number</td>
                  <td>${item.from_number || '-'}</td>
                </tr>
                <tr>
                  <td class="fw-bold">Destination</td>
                  <td>${item.destination || '-'}</td>
                </tr>
                <tr>
                  <td class="fw-bold">Application</td>
                  <td>${item.application || '-'}</td>
                </tr>
                <tr>
                  <td class="fw-bold">Status</td>
                  <td>
                    <span class="badge ${
                      item.status === 1 ? 'bg-success' :
                      (item.status === 0 || item.status === 3) ? 'bg-warning' : 'bg-danger'
                    }">
                      ${this.formatStatusLabel(item.status)}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td class="fw-bold">File URL</td>
                  <td>
                    ${item.file ? `<a href="${item.file}" target="_blank" class="text-break">${item.file}</a>` : '-'}
                  </td>
                </tr>
                <tr>
                  <td class="fw-bold">Error Count</td>
                  <td>${item.error_count}</td>
                </tr>
                <tr>
                  <td class="fw-bold">Error Message</td>
                  <td class="text-danger">${item.msg_error || '-'}</td>
                </tr>
                <tr>
                  <td class="fw-bold">Sending Datetime</td>
                  <td>${this.formatDate(item.sending_datetime)}</td>
                </tr>
                <tr>
                  <td class="fw-bold">Insert Datetime</td>
                  <td>${this.formatDate(item.insert_datetime)}</td>
                </tr>
                <tr>
                  <td class="fw-bold" colspan="2">Message Content</td>
                </tr>
                <tr>
                  <td colspan="2" class="p-2 bg-light text-start" style="white-space: pre-wrap; font-family: monospace; max-height: 200px; overflow-y: auto;">${item.messages || '-'}</td>
                </tr>
              </tbody>
            </table>
          </div>
        `,
        confirmButtonText: 'Close',
        confirmButtonColor: '#6c757d',
        width: '600px',
        didOpen: () => {
          lottie.loadAnimation({
            container: document.getElementById('lottie-detail-queue'),
            renderer: 'svg',
            loop: true,
            autoplay: true,
            path: '/assets/success.json'
          });
        }
      });
    },

    Toasttt(msg, type, detail) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        background: "#F8F8F8",
        didOpen: (toast) => {
          toast.onmouseenter = this.$swal.stopTimer;
          toast.onmouseleave = this.$swal.resumeTimer;
        }
      });
      Toast.fire({
        icon: type,
        title: msg,
        text: detail,
      });
    },

    resetForms() {
      this.activeTab = 'single';
      this.singleForm = {
        destination: '',
        messages: '',
        application: '',
        file: ''
      };
      this.bulkJson = '';
      this.isValidBulkJson = true;
      this.excelFile = null;
      this.isCustomAppInput = false;
      this.destinationCheckStatus = null;
      this.destinationCheckNote = '';
      this.checkingDestination = false;
      this.isImagePreview = true;
      if (this.destCheckTimeout) clearTimeout(this.destCheckTimeout);
      if (this.$refs.excelFileInput) {
        this.$refs.excelFileInput.value = '';
      }
    },

    onDestinationInput() {
      if (this.destCheckTimeout) clearTimeout(this.destCheckTimeout);

      // Strip all non-digit characters
      let num = this.singleForm.destination ? this.singleForm.destination.replace(/\D/g, '') : '';

      // Auto-format 08xxx to 628xxx
      if (num.startsWith('0')) {
        num = '62' + num.slice(1);
      }

      this.singleForm.destination = num;

      if (!num || num.length < 8) {
        this.destinationCheckStatus = null;
        this.destinationCheckNote = '';
        return;
      }

      this.destCheckTimeout = setTimeout(() => {
        this.checkSingleDestinationWA(num);
      }, 600);
    },

    async checkSingleDestinationWA(phone) {
      try {
        this.checkingDestination = true;
        this.destinationCheckStatus = null;
        this.destinationCheckNote = '';

        if (this.availableOnlineInstances.length === 0) {
          const instRes = await axios.get(`${this.baseUrl}/api/instances`, { params: { all: true } });
          const instances = instRes.data?.data?.instances || [];
          this.availableOnlineInstances = instances.filter(i => i.status === 'online');
        }

        if (this.availableOnlineInstances.length === 0) {
          this.destinationCheckStatus = 'no_instance';
          this.destinationCheckNote = 'Tidak ada WhatsApp Instance yang Online untuk verifikasi nomor.';
          return;
        }

        const activeInst = this.availableOnlineInstances[0];
        const res = await axios.post(`${this.baseUrl}/api/check/${activeInst.instanceId}`, {
          phone: phone
        });

        if (res.data?.success && res.data?.data?.isRegistered) {
          this.destinationCheckStatus = 'valid';
          this.destinationCheckNote = `Nomor aktif & terdaftar di WhatsApp (${res.data.data.jid || phone})`;
        } else {
          this.destinationCheckStatus = 'invalid';
          this.destinationCheckNote = res.data?.data?.note || res.data?.message || 'Nomor tidak terdaftar di WhatsApp.';
        }
      } catch (err) {
        console.error('Destination check error:', err);
        this.destinationCheckStatus = 'error';
        this.destinationCheckNote = 'Gagal memverifikasi status WhatsApp nomor ini.';
      } finally {
        this.checkingDestination = false;
      }
    },

    onFileUrlInput() {
      this.isImagePreview = true;
    },

    onMediaPreviewError() {
      this.isImagePreview = false;
    },

    onMediaPreviewLoad() {
      this.isImagePreview = true;
    },

    async downloadExcelTemplate() {
      try {
        this.loadingDownload = true;
        const response = await axios.get(
          `${this.baseUrl}/api/blast-outbox/template-excel`,
          { responseType: 'blob' }
        );

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'template_broadcast_outbox.xlsx');
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

        this.Toasttt('Template Excel berhasil diunduh', 'success');
      } catch (error) {
        console.error('Gagal mengunduh template Excel:', error);
        this.Toasttt('Gagal mengunduh template Excel', 'error');
      } finally {
        this.loadingDownload = false;
      }
    },

    handleExcelFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.excelFile = file;
      }
    },

    async submitExcelImport() {
      if (!this.excelFile) {
        this.Toasttt('Silakan pilih file Excel terlebih dahulu', 'warning');
        return;
      }

      try {
        this.loadingSubmit = true;
        const formData = new FormData();
        formData.append('file', this.excelFile);

        const response = await axios.post(
          `${this.baseUrl}/api/blast-outbox/import-excel`,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        );

        if (response.data?.success) {
          const modalEl = document.getElementById('createQueueModal');
          const modal = bootstrap.Modal.getInstance(modalEl);
          if (modal) modal.hide();

          await this.$swal.fire({
            title: 'Import Success!',
            text: response.data?.message || 'Data queue dari Excel berhasil diimport.',
            icon: 'success',
            confirmButtonColor: this.themeColor
          });

          this.excelFile = null;
          if (this.$refs.excelFileInput) {
            this.$refs.excelFileInput.value = '';
          }

          this.fetchData();
        } else {
          this.Toasttt(response.data?.message || 'Gagal mengimport file Excel.', 'error');
        }
      } catch (error) {
        console.error('Failed to import excel:', error);
        this.Toasttt(
          'Gagal mengimport Excel',
          'error',
          error.response?.data?.message || ''
        );
      } finally {
        this.loadingSubmit = false;
      }
    },

    validateBulkJson() {
      if (this.bulkJson.trim() === '') {
        this.isValidBulkJson = true;
        return;
      }
      try {
        const parsed = JSON.parse(this.bulkJson);
        this.isValidBulkJson = Array.isArray(parsed);
      } catch (e) {
        this.isValidBulkJson = false;
      }
    },

    loadBulkExample() {
      const example = [
        {
          "destination": "628123456781",
          "messages": "Halo pelanggan A, pesan broadcast Anda...",
          "application": "MARKETING"
        },
        {
          "destination": "628123456782",
          "messages": "Halo pelanggan B, pesan broadcast Anda...",
          "application": "MARKETING"
        }
      ];
      this.bulkJson = JSON.stringify(example, null, 2);
      this.isValidBulkJson = true;
    },

    async submitSingleQueue() {
      try {
        this.loadingSubmit = true;
        
        const payload = { ...this.singleForm };
        if (!payload.application) delete payload.application;
        if (!payload.file) delete payload.file;

        const response = await axios.post(
          `${this.baseUrl}/api/blast-outbox/queue`,
          payload
        );

        if (response.data?.success) {
          // Close modal using Bootstrap instance
          const modalEl = document.getElementById('createQueueModal');
          const modal = bootstrap.Modal.getInstance(modalEl);
          if (modal) modal.hide();

          await this.$swal.fire({
            title: 'Success!',
            html: `
              <div id="lottie-success-queue" style="width:180px; height:180px; margin:0 auto;"></div>
              <p class="mt-2">Broadcast Queue successfully added.</p>
            `,
            confirmButtonText: 'OK',
            confirmButtonColor: this.themeColor,
            didOpen: () => {
              lottie.loadAnimation({
                container: document.getElementById('lottie-success-queue'),
                renderer: 'svg',
                loop: false,
                autoplay: true,
                path: '/assets/success.json'
              });
            }
          });

          this.fetchData();
        } else {
          this.Toasttt(response.data?.message || 'Gagal menambahkan queue.', 'error');
        }
      } catch (error) {
        console.error('Failed to submit single queue:', error);
        this.Toasttt(
          'Gagal menambahkan queue',
          'error',
          error.response?.data?.message || ''
        );
      } finally {
        this.loadingSubmit = false;
      }
    },

    async submitBulkQueue() {
      this.validateBulkJson();
      if (!this.isValidBulkJson || this.bulkJson.trim() === '') return;

      try {
        this.loadingSubmit = true;
        const payload = JSON.parse(this.bulkJson);

        const response = await axios.post(
          `${this.baseUrl}/api/blast-outbox/queue`,
          payload
        );

        if (response.data?.success) {
          const modalEl = document.getElementById('createQueueModal');
          const modal = bootstrap.Modal.getInstance(modalEl);
          if (modal) modal.hide();

          await this.$swal.fire({
            title: 'Success!',
            html: `
              <div id="lottie-success-queue" style="width:180px; height:180px; margin:0 auto;"></div>
              <p class="mt-2">Bulk Broadcast Queue successfully added.</p>
            `,
            confirmButtonText: 'OK',
            confirmButtonColor: this.themeColor,
            didOpen: () => {
              lottie.loadAnimation({
                container: document.getElementById('lottie-success-queue'),
                renderer: 'svg',
                loop: false,
                autoplay: true,
                path: '/assets/success.json'
              });
            }
          });

          this.fetchData();
        } else {
          this.Toasttt(response.data?.message || 'Gagal menambahkan bulk queue.', 'error');
        }
      } catch (error) {
        console.error('Failed to submit bulk queue:', error);
        this.Toasttt(
          'Gagal menambahkan bulk queue',
          'error',
          error.response?.data?.message || ''
        );
      } finally {
        this.loadingSubmit = false;
      }
    }
  }
};
</script>

<style scoped>
.spin-icon {
  display: inline-block;
  animation: spin 1.5s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.pagination .page-item.active .page-link {
  color: #ffffff !important;
  background-color: #0d6efd !important;
  border-color: #0d6efd !important;
  font-weight: 600;
}

.pagination .page-link {
  color: #333333;
  font-weight: 500;
}

.pagination .page-link:hover {
  color: #0d6efd;
}

.pagination .page-item.disabled .page-link {
  color: #6c757d;
  background-color: #f1f3f5;
}

.fade-in-child-row {
  animation: fadeInChild 0.25s ease-out forwards;
}

@keyframes fadeInChild {
  from {
    opacity: 0;
    transform: translateY(-6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
